
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veterans",
      function () {
        return require("private-next-pages/veterans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veterans"])
      });
    }
  